
import type { PlacementDensity } from '../../types/api';
import type { AppliedDensity } from './types';

export interface DensityForm {
  profile: string;
  insertsPerMinute: string;
  insertsPer100Words: string;
  minInsertMs: string;
  maxInsertMs: string;
  minGapMs: string;
  hookGuardMs: string;
  tailGuardMs: string;
  allowAdjacent: boolean;
  alternatives: string;
  allowMediaReuse: boolean;
}

export const EMPTY_DENSITY: DensityForm = {
  profile: 'default',
  insertsPerMinute: '',
  insertsPer100Words: '',
  minInsertMs: '',
  maxInsertMs: '',
  minGapMs: '',
  hookGuardMs: '',
  tailGuardMs: '',
  allowAdjacent: false,
  alternatives: '3',
  allowMediaReuse: false,
};

export function densityFormOf(applied: AppliedDensity, base: DensityForm): DensityForm {
  const text = (value: number | null): string => (value === null ? '' : String(value));
  return {
    ...base,
    profile: applied.profile,
    insertsPerMinute: text(applied.insertsPerMinute),
    insertsPer100Words: text(applied.insertsPer100Words),
    minInsertMs: text(applied.minInsertMs),
    maxInsertMs: text(applied.maxInsertMs),
    minGapMs: text(applied.minGapMs),
    hookGuardMs: text(applied.hookGuardMs),
    tailGuardMs: text(applied.tailGuardMs),
    allowAdjacent: applied.allowAdjacent,
  };
}

export function densityPayload(form: DensityForm): PlacementDensity {
  const density: PlacementDensity = { profile: form.profile, allow_adjacent: form.allowAdjacent };
  const put = (key: string, raw: string) => {
    if (raw.trim() === '') return;
    const value = Number(raw);
    if (Number.isFinite(value)) (density as Record<string, unknown>)[key] = value;
  };
  put('inserts_per_minute', form.insertsPerMinute);
  put('inserts_per_100_words', form.insertsPer100Words);
  put('min_insert_ms', form.minInsertMs);
  put('max_insert_ms', form.maxInsertMs);
  put('min_gap_ms', form.minGapMs);
  put('hook_guard_ms', form.hookGuardMs);
  put('tail_guard_ms', form.tailGuardMs);
  return density;
}
